import { gql } from '@apollo/client';

import { query } from '../apollo/ApolloClient';
import { MetricsQueryResult, getDatapoints } from './timeseries';

const ANALYTICS_TIMESERIES_QUERY = gql`
  query analyticsTimeseries(
    $startTime: Time!
    $endTime: Time!
    $metricsName: String!
    $stepSec: Int
    $selectors: MapString!
  ) {
    analyticsTimeseries(
      startTime: $startTime
      endTime: $endTime
      metricsName: $metricsName
      stepSec: $stepSec
      selectors: $selectors
    ) {
      result {
        low {
          labels
          values {
            timestamp
            value
          }
        }
        high {
          labels
          values {
            timestamp
            value
          }
        }
        isAnomaly {
          labels
          values {
            timestamp
            value
          }
        }
      }
    }
  }
`;

interface AnalyticsMetricsQueryResponse {
  result: AnalyticsMetricsQueryResult[];
}

interface AnalyticsMetricsQueryResult {
  low: MetricsQueryResult;
  high: MetricsQueryResult;
  isAnomaly: MetricsQueryResult;
}

interface AnalyticsResponse {
  low: (string | number | null)[][];
  high: (string | number | null)[][];
  isAnomaly: (string | number | null)[][];
}

const TIME_INTERVAL_SEC = 60;

export const getAnalyticsTimeseries = async (
  startTime: string,
  endTime: string,
  metricsName: string,
  selectors: Record<string, string>
): Promise<AnalyticsResponse[] | null> => {
  try {
    const data = await query<Record<string, AnalyticsMetricsQueryResponse>>({
      query: ANALYTICS_TIMESERIES_QUERY,
      variables: {
        startTime,
        endTime,
        metricsName,
        stepSec: TIME_INTERVAL_SEC,
        selectors,
      },
    });
    if (data && data.analyticsTimeseries && data.analyticsTimeseries.result) {
      const { result } = data.analyticsTimeseries;
      return result.map((timeseries) => ({
        low: getDatapoints(startTime, endTime, timeseries.low.values),
        high: getDatapoints(startTime, endTime, timeseries.high.values),
        isAnomaly: getDatapoints(startTime, endTime, timeseries.isAnomaly.values),
      }));
    }
  } catch (error) {
    console.log(`There was an error while fetching timeseries data: ${JSON.stringify(error)}`);
  }
  return null;
};
